import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../config/firebase.js';
import logger from '../../../utils/logger';

export function InlineRating({ document, docRef, oneCollection, docMain, twoCollection }) {
  const [currentRating, setCurrentRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [average, setAverage] = useState(
    document.rating && document.ratingAmount
      ? (document.rating / document.ratingAmount).toFixed(1)
      : null
  );
  const [count, setCount] = useState(document.ratingAmount || 0);

  const handleRate = async (rating) => {
    try {
      const newTotal = (document.rating || 0) + rating;
      const newAmount = (document.ratingAmount || 0) + 1;
      const newAverage = newTotal / newAmount;

      const ref = docRef || doc(db, oneCollection, docMain, twoCollection, document.id);
      await updateDoc(ref, {
        rating: newTotal,
        ratingAmount: newAmount,
      });

      setCurrentRating(rating);
      setAverage(newAverage.toFixed(1));
      setCount(newAmount);
      document.rating = newTotal;
      document.ratingAmount = newAmount;
    } catch (err) {
      logger.error('Error updating rating:', err);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex gap-0.5 mb-0.5">
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          const isFilled = starValue <= (hoverRating || currentRating);
          return (
            <span
              key={starValue}
              className={`text-lg cursor-pointer transition-colors ${isFilled ? 'text-yellow-400' : 'text-gray-300'}`}
              onMouseEnter={() => setHoverRating(starValue)}
              onMouseLeave={() => setHoverRating(0)}
              onClick={() => handleRate(starValue)}
            >
              ★
            </span>
          );
        })}
      </div>
      <span className="text-xs text-gray-500 font-medium">
        {average ? `${average} ${count ? `(${count})` : ''}` : 'Unrated'}
      </span>
    </div>
  );
}
